import classNames from "classnames/bind";
import styles from "./User.module.css";
import { Pagination, Table, Toast } from "../../../../components";
import { Close } from "../../../../components/Icons/Icons";
import { useEffect, useState } from "react";
import axiosClient from "../../../../services/axiosClient";
const cx = classNames.bind(styles);

function ModalPermission({ onClose, info, count }) {
    const [dataTb, setDataTb] = useState([])
    const [pages, setPages] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const columns = [
        {
            label: "STT",
            key: "stt",
        },
        {
            label: "Tên camera",
            key: "nameCam",
        },
        {
            label: "Kho",
            key: "wareHouse",
        },
        {
            label: "Trạng thái",
            key: "status",
        },
    ];
    const getCamOfUser = async (code) => {
        try {
            const res = await axiosClient.get("/userCam/get-list-cam-userCam/", {
                params: {
                    username: code,
                    page: currentPage,
                    size: 10,
                    company_code: info.COMPANY_CODE,
                }
            })
            let dataCam = res?.data?.map((item, index) => {
                return {
                    stt: index + 1,
                    code: item.CODE,
                    nameCam: item.NAME_CAM,
                    wareHouse: item.WAREHOUSE_NAME,
                    status: item.STATUS === 'On' ? 'Hoạt động' : 'Sẵn sàng'
                }
            })
            setDataTb(dataCam)
            setPages(Math.ceil(count / 10))
        }
        catch (e) {
            if (e.response.status === 403) {
                Toast.open("Bạn không có quyền phân camera cho người dùng", "danger")
            }
        }
    }

    useEffect(() => {
        getCamOfUser(info?.USERNAME)
    }, [info, currentPage])

    const handleNext = () => {
        setCurrentPage(currentPage + 1)
    }

    const handlePrevious = () => {
        setCurrentPage(currentPage - 1)
    }

    const handleChosePage = (page) => {
        setCurrentPage(page)
    }

    

    return (
        <div className={cx('modal-permission')}>
            <div className={cx('content-modal-per')}>
                <div className={cx('header', 'header-modal-per')}>
                    Phân quyền tài khoản
                    <div className={cx('button-close')} onClick={onClose}>
                        <Close />
                    </div>
                </div>
                <div className={cx('body')}>
                    <div className={cx('item-info')}>
                        <p className={cx('label')}>Tên người dùng: </p>
                        <p className={cx('content-role')}>{info?.NAME ? info.NAME : ''}</p>
                    </div>
                    <p className={cx('label')}>Danh sách camera: </p>
                    <Table
                        data={dataTb}
                        colum={columns}
                    />
                    <div className={cx('pagination')}>
                        {dataTb?.length > 0 && (
                            <Pagination
                                pages={pages}
                                currentPage={currentPage}
                                onClick={(data) => handleChosePage(data)}
                                onNext={handleNext}
                                onPrevious={handlePrevious}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalPermission;